<template>
  <b-pagination pills
                id="pagination400"
                align="center"
                @change="onChangePage"
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="meta.per_page"
  ></b-pagination>
</template>

<script>
export default {
  name: "Pagination-400",
  props: ['meta', 'onChangePage'],
  data() {
    return {
      currentPage: 1,
    }
  },
  computed: {
    totalRows() {
      return this.meta.total;
    }
  },
  watch: {
    '$route'(to, from) {
      if (this.$route.query.page != undefined) {
        this.currentPage = this.$route.query.page;
        return true
      }
      if (this.$route.name == 'Product') {
        this.currentPage = 1;
        return true
      } else {
        this.currentPage = this.meta.current_page
        return true
      }
    }
  }
}
</script>

<style>
#pagination400 * {
  z-index: 0 !important;
}
</style>

<style scoped>

</style>